import { all, takeLatest, call, fork, put, select, take } from "redux-saga/effects";
import { messages, success, deleteData } from "../../components/messageBox";
import * as types from "../../constants/actionTypes";
import moment from "moment";
import Config from "../../service/Config";
import Endpoint from "../../service/Endpoint";
import { GET, POST, PUT } from "../../service/api";
import { Header } from "../../constants/headers";
import { setLoader } from "./actions";

const getStateModuleReservasi = (state) => state.ModuleReservasi;

export function* validatePasienCode(params) {
  try {
    yield put(setLoader(true));

    if (params.value) {
      const response = yield call(GET, Config.BASE_URL + Endpoint.MODULE_PASIEN_VALIDATE_CODE_GET + params.value);

      if (response.acknowledge == 1) {
        const dataPasien = response.data;
        let _formValidate = {
          f_id_pasien: dataPasien.f_id_pasien,
          f_kode_pasien: dataPasien.f_kode_pasien,
          f_date_register: dataPasien.f_date_register,
          f_nama_pasien: dataPasien.f_nama_pasien,
          f_telepon_pasien: dataPasien.f_telepon_pasien,
          f_tgl_lahir: dataPasien.f_tgl_lahir,
          f_jenis_kelamin: dataPasien.f_jenis_kelamin,
          f_no_identitas: dataPasien.f_no_identitas,
          f_golongan_darah: dataPasien.f_golongan_darah,
          f_status_perokok: dataPasien.f_status_perokok,
          f_no_alamat_pasien: dataPasien.f_no_alamat_pasien,
          f_catatan: dataPasien.f_catatan,
          f_email_user: dataPasien.f_email_user,
          f_id_negara: dataPasien.f_id_negara,
          temp_lokasi: [dataPasien.f_id_provinsi, dataPasien.f_id_kabupaten, dataPasien.f_id_kecamatan, dataPasien.f_id_desa],
        };
        yield put({ type: types.MODULE_RESERVASI_HANDLE_STATE_CARI_PASIEN, property: "isExist", value: 20 });
        yield put({ type: types.MODULE_RESERVASI_VALIDATE_CODE_SUCCESS, payload: _formValidate });
        messages("Pencarian Berhasil", "Anda dapat melakukan pengisian form reservasi", "success", false, false);
      } else {
        yield put({ type: types.MODULE_RESERVASI_HANDLE_STATE_CARI_PASIEN, property: "isExist", value: 10 });
        messages("Maaf", "Data pasien tidak ditemukan.", "warning", false, false);
      }
    } else {
      yield put({ type: types.MODULE_RESERVASI_HANDLE_STATE_CARI_PASIEN, property: "isExist", value: 10 });
      messages("Error", "Gagal memuat data", "error", false, false);
    }
    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
    messages("Error", error, "error", false, false);
  }
}

export function* validateDokterPoliBy() {
  try {
    yield put(setLoader(true));
    let stateModuleReservasi = yield select(getStateModuleReservasi);

    const _id = JSON.parse(localStorage.getItem("UserData")).f_id_klinik;
    const currentDate = moment().format("YYYY-MM-DD HH:mm:ss");
    const currentDay = moment().day();

    let _body = {
      f_id_klinik: _id,
      f_id_poli: stateModuleReservasi.formReservasi.f_id_poli,
      currentDate: currentDate,
      currentDay: currentDay,
    };

    const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_DOKTER_CHECK_DOKTER_PRAKTEK_POST, _body);

    if (response.acknowledge == 1) {
      yield put({ type: types.MODULE_RESERVASI_VALIDATE_DOKTER_DAN_POLI_SUCCESS, payload: response.data });
    }

    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
    messages("Error", error, "error", false, false);
  }
}

export function* getMasterData() {
  try {
    yield put(setLoader(true));
    const _id = JSON.parse(localStorage.getItem("UserData")).f_id_klinik;

    let _body = {
      MasterData: [
        {
          ObjectName: "listPoli",
          id: _id,
        },
      ],
    };
    const response = yield call(POST, Config.BASE_URL + Endpoint.GET_LIST_MASTER_DATA, _body);
    yield all(yield put({ type: types.MODULE_RESERVASI_MASTER_DATA_SUCCESS, property: "listPoli", value: response.data.listPoli }));
    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
    messages("Error", error, "error", false, false);
  }
}

export function* postFormReservasi(params) {
  try {
    yield put(setLoader(true));
    let stateModuleReservasi = yield select(getStateModuleReservasi);
    const _id = JSON.parse(localStorage.getItem("UserData")).f_id_klinik;

    const _data = stateModuleReservasi.formReservasi;
    const _dataPasien = stateModuleReservasi.formDataPasien;
    const _pasienData = stateModuleReservasi.cariPasien;

    const _body = {
      f_tgl_reservasi: _data.f_tgl_reservasi,
      f_status_reservasi: 0,
      f_status_invoice: 0,
      f_status_obat: 0,
      f_create_on: _data.f_create_on,
      f_catatan: null,
      f_id_klinik: _id,
      f_id_poli: _data.f_id_poli,
      f_id_dokter: _data.f_id_dokter,
      f_id_pasien: _dataPasien.f_id_pasien,
    };

    if (!params.value) {
      const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_RESERVASI_CREATE_POST, _body, { headers: Header() });
      if (response.acknowledge == 1) {
        messages("Berhasil", response.message, "success", false, params.history);
      } else {
        messages("Error", response.message, "error", false, false);
      }
    } else {
      // const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_DOKTER_UPDATE_POST, {..._body, "f_id_dokter": params.value}, { headers: Header() });
      // if (response.acknowledge == 1) {
      //     messages("Berhasil", response.message, "success", false, params.history);
      // }else{
      //     messages("Error", response.message, "error", false, false);
      // }
    }
    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
    messages("Error", error, "error", false, false);
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(types.MODULE_RESERVASI_VALIDATE_CODE, validatePasienCode),
    takeLatest(types.MODULE_RESERVASI_MASTER_DATA, getMasterData),
    takeLatest(types.MODULE_RESERVASI_VALIDATE_DOKTER_DAN_POLI, validateDokterPoliBy),
    takeLatest(types.MODULE_RESERVASI_SUBMIT_FORM_RESERVASI, postFormReservasi),
  ]);
}
